/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { Action } from 'redux';

const welcomeModal = (
  state = { isOpen: false },
  action: Action,
) => {
  switch (action.type) {
    case actionTypes.OPEN_WELCOME_MODAL:
      return { ...state, isOpen: true };
    case actionTypes.CLOSE_WELCOME_MODAL:
      return { ...state, isOpen: false };
    default:
      return state;
  }
};

export default welcomeModal;
